export default {
  rules: state => state.rules,
  getPageLoad: state => state.pageLoad,
  getApi: state => state.api,
  getLk: state => state.lk,
  getSocket: state => state.socket,
  error: state => code => state.error.find(n => n.code === code) || {
    code: 500,
    title: 'Неизвестная ошибка',
    message: 'Неизвестная ошибка'
  },
  getToken: state => {
    let token =  state.token;
    if(!token){
      const getCookie = (name) => {
        let matches = document.cookie.match(new RegExp( "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)" ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
      }
      return getCookie('token')
    }
    return token
  },
  getUser: state => state.user,
}


// WEBPACK FOOTER //
// ./src/store/getters.js